import { render } from "./RedemptionCard.vue?vue&type=template&id=f2156ec4&scoped=true"
import script from "./RedemptionCard.vue?vue&type=script&lang=js"
export * from "./RedemptionCard.vue?vue&type=script&lang=js"

import "./RedemptionCard.vue?vue&type=style&index=0&id=f2156ec4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2156ec4"]])

export default __exports__